var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shareInfoStatus)?_c('div',{staticClass:"poster-first"},[_c('div',{staticClass:"mask-share"},[_c('img',{attrs:{"src":require("@assets/images/share-info.png")},on:{"click":_vm.shareInfoClose}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }